module.exports = __webpack_public_path__ + "static/img/primary-standard.e380461.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/primary-standard.png
// module id = M2ce
// module chunks = 32